import { RouteConfig } from 'vue-router'

const Index = () => import('../../views/contact-us/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/contact-us',
  name: 'contact_us',
  component: Index,
  meta: {
    title: '联系客服',
  },
}

export default [indexRoute]
